// extracted by mini-css-extract-plugin
export var questionBox = "_81-0";